export const HELP_DESK_LINK = 'https://help.bndl.nl';
